<template>
  <div class="login-container">
    <!-- <div class="logo-area">
      <img src="@/assets/logo.png" alt="Logo" class="logo" />
      <h1 class="logo-title">凯尚设计</h1>
    </div> -->
    <form @submit.prevent="updatePwd">
      <div class="form-group">
        <label for="oldpassword">旧密码</label>
        <input
          type="tel"
          id="oldpassword"
          v-model.trim="oldpassword"
          required
          maxlength="30"
          placeholder="请输入旧密码"
        />
      </div>
      <div class="form-group">
        <label for="password">新密码</label>
        <input
          type="password"
          id="password"
          v-model.trim="password"
          required
          minlength="1"
          placeholder="请输入新密码"
        />
      </div>
      <button type="submit" :disabled="loading" class="login-btn">
        {{ loading ? '修改中...' : '立即修改' }}
      </button>
    </form>
    <button @click="goToHome" class="login-btn">
         返回首页
      </button>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useRouter  } from "vue-router";
import { getCurrentInstance } from 'vue';
import { ElMessage } from 'element-plus';

export default {
  setup() {
    const oldpassword = ref('');
    const password = ref('');
    const router = useRouter(); // 获取路由实例
    const { proxy } = getCurrentInstance();

    const updatePwd = async () => {
      const url = '/login/updatePwd';
      proxy.$tools.request(url, 
      {
        reqBody:{oldpassword:oldpassword.value,password:password.value},
      })
        .then(response => {
          if ('00000000' === response.data.rspHead.returnCode) {
              //清除token
              // let token = localStorage.getItem("token"); 
              localStorage.removeItem(localStorage.getItem("token"));
              ElMessage.success('操作成功');
              router.push("/appLogin");
            }else{
            ElMessage.error(response.data.rspHead.returnMsg); // 弹框提示错误信息
          }
        })
        .catch(error => {
          // 处理错误情况
          ElMessage.error('系统异常，请联系管理员'+error); 
        });
    };

    const goToHome = () => {
      router.push('/');
    };




    return {
      oldpassword,
      password,
      updatePwd,
      goToHome
    };
  },
};
</script>

<style scoped>
.login-container {
  max-width: 440px;
  margin: 50px auto;
  padding: 40px 30px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
}

.logo-area {
  text-align: center;
  margin-bottom: 40px;
}

.logo {
  width: 80px;
  height: 80px;
  margin-bottom: 16px;
}

.logo-title {
  font-size: 24px;
  color: #303133;
  font-weight: 500;
  letter-spacing: 2px;
  margin: 0;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.form-group {
  margin-bottom: 24px;
  width: 100%; /* 新增宽度限制 */
  box-sizing: border-box; /* 新增盒模型设置 */
}

label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #606266;
  font-weight: 500;
}

input {
  width: 100%;
  height: 44px;
  padding: 0 16px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.3s ease;
  transition: border-color 0.3s ease;
  box-sizing: border-box; /* 确保padding不影响总宽度 */
}

input:focus {
  border-color: #409eff;
  outline: none;
  box-shadow: 0 0 4px rgba(64, 158, 255, 0.2);
}

input::placeholder {
  color: #c0c4cc;
}

.login-btn {
  width: 100%;
  height: 44px;
  background: linear-gradient(135deg, #409eff, #337ecc);
  color: white;
  font-size: 16px;
  font-weight: 500;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 10px;
}

.login-btn:hover {
  background: linear-gradient(135deg, #337ecc, #409eff);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

.login-btn:disabled {
  background: #c0c4cc;
  cursor: not-allowed;
  box-shadow: none;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .login-container {
    margin: 20px;
    padding: 30px;
  }
  
  .logo-title {
    font-size: 20px;
  }
}
</style>
